import { getLocalStorage } from '@nordvpn/teams.core/lib/tools/localStorageService';
import { STORAGE_NAME_AUTH } from 'pages/LoginOld/constants';
import { refreshToken } from './Auth/utils';
import { tokensRenewMemo } from './utils/axios';
/**
 * Adds token to authorization header.
 */
export var addAuthHeaderInterceptor = function addAuthHeaderInterceptor(request) {
    var storage = getLocalStorage(STORAGE_NAME_AUTH);
    var intercepted = request;
    if (storage !== null && storage !== void 0 && storage.token) {
        intercepted.headers.Authorization = "Bearer ".concat(storage.token);
    }
    return intercepted;
};
/**
 * Refresh expired token.
 */
export var renewTokenInterceptor = function renewTokenInterceptor(axios) {
    return refreshToken(axios, function (token) {
        return tokensRenewMemo(axios, token);
    });
};
